const ERROR_LOCAL_PATHS = ['local.acc-qa.autodesk.com', 'localhost'];

export default (error?: Error): boolean => {
  const [_, file] = error?.stack?.split('\n') || [];
  const isLocal = ERROR_LOCAL_PATHS.some((path) => file?.includes(path));

  if (isLocal) {
    console.log('ExoSkeleton (Local error):', error);
  }

  return isLocal;
};
